import React, { ChangeEvent, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@saucelabs/ds-button';

import operations from '../operations';
import records from '../records';

const UploadFileButton: React.FC = () => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const inputFile = useRef<HTMLInputElement>(null);

  const handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const { target: { files } } = event;

    if (files) {
      const newFile = new records.UploadToSdFile(files[0]);
      void dispatch(operations.uploadToSdCard(newFile));
    }

    if (inputFile.current) {
      inputFile.current.value = '';
    }
  };

  return (
    <>
      <input
        ref={inputFile}
        aria-hidden
        aria-label="file-input"
        onChange={handleFileUpload}
        // can't use tailwind's "hidden" since that's overridden by global CSS
        style={{ display: 'none' }}
        type="file"
      />
      <Button
        onPress={() => { inputFile.current?.click(); }}
        variant="outline"
      >
        Upload File
      </Button>
    </>
  );
};

UploadFileButton.displayName = 'UploadFileToSdCardButton';

export default UploadFileButton;
